import { Linking, View  } from 'react-native';
import { Button } from './Button';

import * as WebBrowser from 'expo-web-browser';
const OpenLinkButton= props =>{
  
    async function handlePress () {
    await WebBrowser.openBrowserAsync(props.url);
  }

    return (
        <View style={{width:'100%', height:'10%', alignItems:'center', justifyContent:'center'}}>
        <Button
        color={'#F9BA49'}
        width={'70%'}
        text={props.text}
        textColor={'#202020'}
        onPress={() => {
          handlePress();
        }}
        borderColor={'#202020'}
      />
      </View>
    );
  };

  export default OpenLinkButton